// Public Share > Embed URLs copied from Google Maps.
// Kota IPIA and Ramganj Mandi use the owner's verified Google Business listings
// (shared 2026-11-04); Ranpur is still an area map, not a verified factory-gate pin.
export const UNITS = [
  {
    id: "kota", label: "Kota · IPIA", name: "Garg Stone Company",
    area: "Indraprastha Industrial Area, Kota",
    verified: true,
    pinNote: "Pin shows our Google Business listing on Road Number 6, IPIA — the main yard for visits and pickups.",
    addresses: ["G-329, Road Number 6, Indraprastha Industrial Area (RIICO IPIA), Kota, Rajasthan 324005, India", "H1-226(K), RIICO IPIA, Kota, Rajasthan, India"],
    listingUrl: "https://maps.google.com/?cid=4756032706190950519",
    directionsUrl: "https://www.google.com/maps/dir/?api=1&destination=25.1270691,75.870988",
    embedSrc: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3612.2549784999064!2d75.870988!3d25.1270691!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396f8599ab8aa543%3A0x4200d28c38a6c077!2sKota%20Stone%20Tiles%20(%20GARG%20STONE%20COMPANY%20KOTA%20)%20Kota%20stone%20manufacturer%20%7C%20kota%20stone%20supplier%20%7C%20kota%20stone%20wholeseller!5e0!3m2!1sen!2s!4v1793818329086!5m2!1sen!2s",
  },
  {
    id: "ramganj-mandi", label: "Ramganj Mandi", name: "Garg Minerals",
    area: "RIICO industrial area, Gundi Fatehpur",
    verified: true,
    pinNote: "Pin shows our Google Business listing at E-45, Gundi Fatehpur industrial area — the Ramganj Mandi quarry-side yard.",
    addresses: ["E-45, Industrial Area, Gundi Fatehpur, Ramganj Mandi, Rajasthan 326529, India"],
    listingUrl: "https://maps.google.com/?cid=11094439554701431975",
    directionsUrl: "https://www.google.com/maps/dir/?api=1&destination=24.6990211,75.9300511",
    embedSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3624.811054741583!2d75.9300511!3d24.6990211!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39656d735b2587e9%3A0x99f75dfe800594a7!2sKota%20Stone%20Tile%20(%20Garg%20Minerals%20)%20Kota%20Stone%20Supplier%20in%20Ramganj%20Mandi!5e0!3m2!1sen!2s!4v1793818782227!5m2!1sen!2s",
  },
  {
    id: "ranpur", label: "Kota · Ranpur", name: "Garg Minerals — Ranpur",
    area: "Ranpur, Kota",
    addresses: ["E-249, Kuber Extension, RIICO, Ranpur, Kota, Rajasthan, India"],
    embedSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d28915.796103887023!2d75.83436884999999!3d25.051901349999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396f85d1c78f6675%3A0xf5ade9321005bbca!2sRanpur%2C%20Rajasthan%20325003%2C%20India!5e0!3m2!1sen!2s!4v1793050297873!5m2!1sen!2s",
  },
];

export const mapSearchUrl = (address) => `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
